import '../../blocks/articles-slider/articles-slider.js';
import '../../blocks/cases-slider/cases-slider.js';
